import styles from './Event.module.scss';
import React, { useState, useEffect, useMemo } from 'react';
import { TableList } from "../../../components";
import common from '../../../common';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Event({ cateIdx, type }) {

    const { useAlert, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
    const [data, setData] = useState([]);
    
    const tableLoadData = {
        tableType: 'Event',
        type: type,
        cate: [cateIdx]
    };


    const fetchData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_document/out/get_table`, tableLoadData , {
                withCredentials: true
            });

            if (response.data.result === 't') {
                const data = response.data.data;
                setData(data);
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Data fetching failed:', error);
        } finally {
            pLoadingOff();
        }
    }

    useEffect(() => {
        fetchData();
    }, []);


    const columns = useMemo(() => [
        { title: '행사내용', dataIndex: 'event_title', className: 'p_td_event text_start' },
    ], []);

    const pageSize = 10;
    const categoryOptions = useMemo(() => [
        { label: '전체', value: '전체' },
        { label: '제목', value: 'title' },
        { label: '내용', value: 'contents' },
    ], []);



    return (
        <>
            <div className="components_wrap">
                <span className='components_wrap_title'>행사접수</span>
                <TableList data={data} columns={columns} pageSize={pageSize} categoryOptions={categoryOptions} type={"Event"}/>
            </div>
        </>
    );
}

export default Event;